export enum AtiraLinkPlanMobileApp {
  PLAN_0 = 'unlimited',
  PLAN_1 = 'unlimited',
  PLAN_2 = 'unlimited',
}
